import React, { useState } from 'react';
import ModalView from '../views/ModalView';

function PortfolioCard({ project, featured, index }) {
    const [open, setOpen] = useState(false);
    const [imageIndex, setImageIndex] = useState(0);
    const openProject = () => { setImageIndex(0); setOpen(true); };

    return (
        <>
            <article className={`project-card${featured ? ' project-featured' : ''}`}>
                <button className={`project-image project-image-${index % 3}`} type="button" onClick={openProject} aria-label={`Explore ${project.name}`}>
                    <img src={project.images[0]} alt={project.captions[0]} loading="lazy" decoding="async" width="960" height="600" />
                    <span className="image-open" aria-hidden="true">↗</span>
                </button>
                <div className="project-copy">
                    <p className="eyebrow">{project.client}</p>
                    <h3>{project.title}</h3>
                    <p className="project-summary">{project.summary}</p>
                    <ul className="tags" aria-label="Project disciplines">{project.tags.map(tag => <li key={tag}>{tag}</li>)}</ul>
                    <button className="text-link" type="button" onClick={openProject}>Explore project <span aria-hidden="true">↗</span><span className="sr-only">: {project.name}</span></button>
                </div>
            </article>
            {open && (
                <ModalView title={project.name} onClose={() => setOpen(false)}>
                    <p className="eyebrow">{project.client} / {project.role}</p>
                    <div className="case-gallery">
                        <img src={project.images[imageIndex]} alt={project.captions[imageIndex]} />
                    </div>
                    <div className="gallery-controls">
                        <p aria-live="polite">{imageIndex + 1} / {project.images.length} — {project.captions[imageIndex]}</p>
                        <div>
                            <button className="icon-button" type="button" aria-label="Previous screenshot" onClick={() => setImageIndex((imageIndex - 1 + project.images.length) % project.images.length)}>←</button>
                            <button className="icon-button" type="button" aria-label="Next screenshot" onClick={() => setImageIndex((imageIndex + 1) % project.images.length)}>→</button>
                        </div>
                    </div>
                    <div className="case-details">
                        <section><h3>The context</h3><p>{project.context}</p></section>
                        <section><h3>My contribution</h3><p>{project.contribution}</p></section>
                        <section><h3>The result</h3><p>{project.result}</p></section>
                    </div>
                </ModalView>
            )}
        </>
    );
}

export default PortfolioCard;
